import { render, staticRenderFns } from "./MessagesPinned.vue?vue&type=template&id=ecb3be62&"
import script from "./MessagesPinned.vue?vue&type=script&lang=js&"
export * from "./MessagesPinned.vue?vue&type=script&lang=js&"
import style0 from "./MessagesPinned.vue?vue&type=style&index=0&id=ecb3be62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports